import React from 'react';
import { useIntl } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import BreadcrumbStepPropType from '../definitions/BreadcrumbStepPropType';
import Colours from '../definitions/Colours';
import MessagePropType from '../definitions/MessagePropType';
import messageToString from '../functions/messageToString';
import BreadcrumbTrail from './BreadcrumbTrail';
import IconChooser from './IconChooser';


function ProgressIndicator({
    steps,
    onBreadcrumbClick,
    helpMessage,
    className,
    children,
}) {
    const intl = useIntl();

    return (
        <div className={className}>
            <BreadcrumbTrail
                steps={steps}
                className="rh-mb-2"
                onBreadcrumbClick={onBreadcrumbClick}
            />

            <If condition={helpMessage}>
                <div className="rh-display-flex rh-pt-2 rh-ml-0_5 rh-bt-1px-solid-stone rh-text-lowercase">
                    <IconChooser
                        className="rh-flex-shrink-0"
                        iconKey="clock"
                        size="XS"
                        stroke={Colours.BLUEBERRY}
                    />
                    <p className="rh-text-s rh-p-0 rh-my-0 rh-ml-1">
                        {messageToString(helpMessage, intl)}
                    </p>
                </div>
            </If>

            {children}
        </div>
    );
}

ProgressIndicator.propTypes = {
    steps: PropTypes.arrayOf(
        BreadcrumbStepPropType,
    ).isRequired,
    onBreadcrumbClick: PropTypes.func,
    helpMessage: MessagePropType,
    className: PropTypes.string,
    children: PropTypes.node,
};


export default observer(ProgressIndicator);
